// popup-video.js
document.addEventListener('alpine:init', () => {
    Alpine.data('popupVideo', () => ({
        open: false,
        visible: true,
        toggleOpen() {
            if (!this.open) {
                this.open = true;
                this.$nextTick(() => {
                    this.$refs.video.muted = false;
                    this.$refs.video.play();
                    this.$refs.video.controls = true;
                    //document.body.classList.add('overflow-hidden-tablet');
                });
            }
        },
        closePopup() {
            this.open = false;
            this.$refs.video.muted = true;
            this.$refs.video.controls = false;
            this.$refs.video.play();
            //document.body.classList.remove('overflow-hidden-tablet');
        },
        hideVideoPopup() {
            this.visible = false;
            //document.body.classList.remove('overflow-hidden-tablet');
        }
    }))
})